export default __webpack_public_path__ + "static/media/maths1.6a46c2e6.png";